module.exports = __webpack_public_path__ + "img/d3bf94c.png";